import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AboutUsPages } from 'src/app/models/aboutUs-pages.model';
import { AboutUsService } from 'src/app/services/about-us.service';
import { LookUpService } from 'src/app/services/lookup.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { HeaderStyleTwoComponent } from '../header-style-two/header-style-two.component';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
})
export class PrivacyPolicyComponent implements OnInit {
  aboutUsPages: AboutUsPages;
  img: string;
  logo: string;
  constructor(private aboutUsService: AboutUsService,
    private lookUpService: LookUpService,

  ) { }

  createImgPath = (serverPath: string) => {
    return this.aboutUsService.createImgPath(serverPath);
  }

  ngOnInit(): void {
    this.aboutUsService.getAll$().subscribe(x => {
      this.aboutUsPages = x.find(x => x.pageID == 2);
    });
    this.lookUpService.getAll$().subscribe(x => {
      this.img = x.find(x => x?.name == "PrivacyPolicy_Header_Img")?.value;
      this.logo = x.find(x => x?.name == "Logo")?.value;
    });
  }

}

